import { FormHelperText } from '@material-ui/core'
import { Field, FieldProps } from 'formik'
import React from 'react'
import { IBB8FieldProps } from './BB8FormField'
import StyledBB8Lookup, { IBB8LookupProps } from './BB8Lookup'

const BB8FormLookupField = (props: IBB8FieldProps & IBB8LookupProps) => (
  <Field name={props.name} validate={props.validate} {...props}>
    {({ field, form }: FieldProps) => {
      return (
        <>
          <FormHelperText
            error={
              !props.disabled &&
              (!!props.error || !!(form.touched[field.name] && form.errors[field.name]))
            }
          >
            {props.label}
          </FormHelperText>
          <StyledBB8Lookup
            id={props.id}
            placeholder={props.placeholder}
            onInputBlur={form.handleBlur}
            // tslint:disable-next-line:jsx-no-lambda
            onSelect={(value: any) => {
              if (props.valuePath) {
                form.setFieldValue(
                  field.name,
                  value
                    ? value[props.valuePath]
                    : props.defaultValue
                      ? props.defaultValue[props.valuePath]
                      : undefined
                )
              } else {
                form.setFieldValue(field.name, value || props.defaultValue)
              }
            }}
            options={props.options}
            {...props}
            {...field}
          />
          <FormHelperText
            className="margin-20-top rem-1-font"
            error={
              !props.disabled &&
              (!!props.error || !!(form.touched[field.name] && form.errors[field.name]))
            }
          >
            {form.errors[field.name] && !!form.touched[field.name] ? form.errors[field.name] : ''}
          </FormHelperText>
        </>
      )
    }}
  </Field>
)

export default BB8FormLookupField
